import React from 'react';
import classNames from 'classnames';
import config from 'react-global-configuration';
import { CoreLink, ImageFromField } from '@uncinc/react-drupal-core';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { Map } from 'immutable';

import { SCREEN_MOBILE, SCREEN_NORMAL, SCREEN_TABLET, SCREEN_WIDE } from '../../../../config/constants';

import './style.scss';
import { prependApiURLToImageStyles } from '../../../../helpers/prependApiURL';

const NodeArticleTeaser = ({ entity, className }) => {
  const DEFAULT_LANGUAGE = config.get('DEFAULT_LANGUAGE');
  const classes = classNames(className, 'ArticleTeaser');

  const path = entity.getIn(['paths', DEFAULT_LANGUAGE], '');
  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const mediaItem = entity.getIn(['field_media_item', 0], Map());

  const created = entity.getIn(['created', 0, 'value'], '');
  const date = new Date(created);
  const dateFormatted = new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' }).format(date);

  return (
    <CoreLink to={path} title={title} className={classes}>
      <article itemScope itemType="https://schema.org/WebPage">
        <div className="ArticleTeaser__image">
          {mediaItem.get('styles') && (
            <ImageFromField
              field={prependApiURLToImageStyles(mediaItem)}
              imageStyles={Map({
                [SCREEN_MOBILE]: 'crop_crop_hero_teaser',
                [SCREEN_TABLET]: 'crop_crop_hero_teaser',
                [SCREEN_NORMAL]: 'crop_crop_hero_teaser',
                [SCREEN_WIDE]: 'crop_crop_hero_teaser',
              })}
            />
          )}
          <div className="ArticleTeaser__image__addon">
            <div className="icon icon-after icon-arrow icon-variant-4" />
          </div>
        </div>
        <div className="ArticleTeaser__content">
          <time dateTime={date} className="ArticleTeaser__content__date">{dateFormatted}</time>
          <h2 className="asH3">{title}</h2>
          <WysiwygField html={body} />
        </div>
      </article>
    </CoreLink>
  );
};

export default NodeArticleTeaser;
